// stores/itemStore.js
import { create } from "zustand";
import axios from "axios";
import authHeader from "../../services/auth-header";
import { APP_URL } from "../../services/http-common";
import useGlobalStore from "./globalStoreZs";
import { PageSize } from "docx";

const URLEntityName = APP_URL + "forms-formula";

const useFormsFormulaStore = create((set, get) => ({
  formsFormulaZs: [],
  formFormulaZs: {},

  total: 0,
  searchTextFormulaZs: "",
  currentPageFormulaZs: 0,
  pageSizeFormulaZs: 10,
  setSearchTextFormulaZs: (text) => {
    set({ searchTextFormulaZs: text, currentPageFormulaZs: 0 });
    // get().setFilterLinesZs();
  },
  setPageFormulaZs: (page) => {
    set({ currentPageFormulaZs: page });
    get().setFilterFormulaZs();
  },
  totalPagesFormulaZs: () => {
    const { formsFormulaZs, searchTextFormulaZs, pageSizeFormulaZs } = get();
    const filtered = formsFormulaZs.filter((item) =>
      item?.name?.toLowerCase().includes(searchTextFormulaZs.toLowerCase())
    );
    return Math.ceil(filtered.length / pageSizeFormulaZs);
  },
  filterFormulaZs: [],
  setFilterFormulaZs: () => {
    const {
      formsFormulaZs,
      searchTextFormulaZs,
      currentPageFormulaZs,
      pageSizeFormulaZs,
    } = get();
    const filtered = formsFormulaZs.filter((row) => {
      return Object.keys(row)
        .filter((key) => key !== "id") // Exclude 'id' from the search
        .some((key) => {
          const value = row[key];
          // Check if the value is a string and contains the search text
          return (
            typeof value === "string" &&
            value.toLowerCase().includes(searchTextFormulaZs.toLowerCase())
          );
        });
    });
    const totalPages = Math.ceil(filtered.length / pageSizeFormulaZs);

    // Ensure the current page does not exceed total pages
    const currentPage = Math.min(currentPageFormulaZs, totalPages - 1);

    const start = currentPageFormulaZs * pageSizeFormulaZs;
    const end = start + pageSizeFormulaZs;

    set({
      filterFormulaZs: filtered.slice(start, end),
      totalPagesFormulaZs: totalPages,
      currentPageFormulaZs: currentPage,
      total: filtered.length,
    });
  },

  evaluateFormFormulaZs: {},
  dataForTableChartZs: {},
  dataForTableChartPostProcessZs: {},

  fetchFormsFormulaZs: async () => {
    set({ loading: true });
    useGlobalStore.getState().setLoadingZs(true);
    const { pageSizeFormulaZs } = get();
    try {
      const response = await axios.get(URLEntityName, {
        headers: authHeader(),
      });

      const newData = response?.data.sort((a, b) => a.order - b.order);
      set({
        formsFormulaZs: newData,
        filterFormulaZs: newData.slice(0, pageSizeFormulaZs),
        total: newData.length,
        searchTextFormulaZs: "",
        currentPageFormulaZs: 0,
      });
    } catch (error) {
      console.error("Error fetching items", error);
    }
    set({ loading: false });
    useGlobalStore.getState().setLoadingZs(false);
  },

  // fetchFormsFormulaZs: async () => {
  //   useGlobalStore.getState().setLoadingZs(true);
  //   set({ loading: true });
  //   try {
  //     const response = await axios.get(URLEntityName, {
  //       headers: authHeader(),
  //     });
  //     set({ formsFormulaZs: response.data });
  //   } catch (error) {
  //     console.error("Error fetching items", error);
  //   }
  //   set({ loading: false });
  //   useGlobalStore.getState().setLoadingZs(false);
  // },

  //   getFormFormulaZs: async (id) => {
  //     set({ loading: true });
  //     useGlobalStore.getState().setLoadingZs(true);
  //     try {
  //       const response = await axios.get(URLEntityName + "/" + id, {
  //         headers: authHeader(),
  //       });
  //       set({
  //         chapterZs: response.data,
  //       });
  //     } catch (error) {
  //       console.error("Error fetching items", error);
  //     }
  //     set({ loading: false });
  //     useGlobalStore.getState().setLoadingZs(false);
  //   },

  createFormFormulaZs: async (item) => {
    set({ loading: true });
    useGlobalStore.getState().setLoadingZs(true);
    try {
      const response = await axios.post(URLEntityName, item, {
        headers: authHeader(),
      });
      await useFormsFormulaStore.getState().fetchFormsFormulaZs();
      useGlobalStore.getState().setLoadingZs(false);
      useGlobalStore.getState().setMessageZs("Rekordi u shtua me sukses!");
    } catch (error) {
      console.error("Error fetching items", error);
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      useGlobalStore.getState().setMessageZs(message);
    }
    useGlobalStore.getState().setLoadingZs(false);
    set({ loading: false });
  },

  updateFormFormulaZs: async (item) => {
    set({ loading: true });
    useGlobalStore.getState().setLoadingZs(true);
    try {
      const response = await axios.put(URLEntityName + "/" + item?.id, item, {
        headers: authHeader(),
      });
      //   await useFormInputesSubmissionStore.getState().getReportZs(item?.id);
      await useFormsFormulaStore.getState().fetchFormsFormulaZs();
      useGlobalStore.getState().setLoadingZs(false);
      useGlobalStore.getState().setMessageZs("Formula u ndryshuar me sukses!");
    } catch (error) {
      console.error("Error fetching items", error);
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      useGlobalStore.getState().setMessageZs(message);
    }
    useGlobalStore.getState().setLoadingZs(false);
    set({ loading: false });
  },

  deleteFormFormulaZs: async (item) => {
    useGlobalStore.getState().setLoadingZs(true);
    try {
      const response = await axios.delete(URLEntityName + "/" + item?.id, {
        headers: authHeader(),
      });
      await useFormsFormulaStore.getState().fetchFormsFormulaZs();
      useGlobalStore.getState().setLoadingZs(false);
      useGlobalStore.getState().setMessageZs("Rekordi u fshi me sukses!");
    } catch (error) {
      console.error("Error delete ", error);
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      useGlobalStore.getState().setMessageZs(message);
    }
    useGlobalStore.getState().setLoadingZs(false);
    set({ loading: false });
  },

  getEvaluateFormFormulaZs: async (item) => {
    set({ loading: true });
    useGlobalStore.getState().setLoadingZs(true);
    try {
      const response = await axios.post(URLEntityName + "/evaluate", item, {
        headers: authHeader(),
      });
      //   await useFormsFormulaStore.getState().fetchFormsFormulaZs();
      set({ evaluateFormFormulaZs: response.data });
      useGlobalStore.getState().setLoadingZs(false);
      useGlobalStore.getState().setMessageZs("Te dhenat u morren me sukses!");
      return response.data;
    } catch (error) {
      console.error("Error fetching items", error);
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      useGlobalStore.getState().setMessageZs(message);
    }
    useGlobalStore.getState().setLoadingZs(false);
    set({ loading: false });
  },

  getDataForTableChartZs: async (type = "API", item, postProcess) => {
    set({ loading: true });
    useGlobalStore.getState().setLoadingZs(true);
    if (type === "API") {
      try {
        const response = await axios.get(APP_URL + item, {
          headers: authHeader(),
        });

        if (
          postProcess &&
          postProcess !== "string" &&
          postProcess !== null &&
          postProcess !== undefined &&
          postProcess !== ""
        ) {
          let groupByType;
          try {
            groupByType = eval(`(${postProcess})`);
            set({
              dataForTableChartPostProcessZs: groupByType(response.data) ?? {},
            });
            useGlobalStore.getState().setLoadingZs(false);
            return response;
          } catch (err) {
            console.error("Eval failed:", err);
            useGlobalStore
              .getState()
              .setMessageZs("Gabim në postProcess: " + err.message);
            useGlobalStore.getState().setLoadingZs(false);
            return err; // stop execution
          }
        }
        set({ dataForTableChartZs: response.data });
        useGlobalStore.getState().setLoadingZs(false);
        useGlobalStore.getState().setMessageZs("Te dhenat u morren me sukses!");
        return response?.data?.content;
      } catch (error) {
        console.error("Error fetching items", error);
        const message =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();
        useGlobalStore.getState().setMessageZs(message);
      }
    } else {
      try {
        const response = await axios.post(URLEntityName + "/evaluate", item, {
          headers: authHeader(),
        });
        //   await useFormsFormulaStore.getState().fetchFormsFormulaZs();
        if (response.data?.all) {
          set({ dataForTableChartZs: response.data?.all });
        } else {
          set({ dataForTableChartZs: response.data });
        }
        useGlobalStore.getState().setLoadingZs(false);
        useGlobalStore.getState().setMessageZs("Te dhenat u morren me sukses!");
      } catch (error) {
        console.error("Error fetching items", error);
        const message =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();
        useGlobalStore.getState().setMessageZs(message);
      }
    }
    useGlobalStore.getState().setLoadingZs(false);
    set({ loading: false });
  },
}));

export default useFormsFormulaStore;
